<template>
  <div>
    <Modal
      :loading="loading"
      v-model="showModel"
      :width="750"
      :title="title"
      @on-ok="save"
      :footer-hide="disabled"
      @on-cancel="closeModel">
      <div class="form-area">
        <Form
          :disabled="disabled" style="width: 750px"
          :model="model"
          :label-width="140"
          label-position="right"
          :rules='rules'
          ref="form"
          inline>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.id" type="text"></Input>
          </FormItem>
          <FormItem label="贷款产品名称:" prop="productName">
            <Input v-model="model.productName" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="担保方式:" prop="guaranteeWay">
            <Input v-model="model.guaranteeWay" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="利率范围:" prop="rate">
            <Input v-model="model.rate" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="贷款期限(月):" prop="timeLimit">
            <Input v-model="model.timeLimit" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="贷款额度(万元):" prop="amount">
            <Input v-model="model.amount" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="产品类别:" prop="type">
            <Input v-model="model.type" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="项目详情:" prop="detail">
            <Input v-model="model.detail" style="width:500px" type="textarea" :maxlength="1000" show-word-limit/>
          </FormItem>
          <FormItem label="产品封面:" prop="cover">
            <upload
              ref="upload"
              v-if="!disabled"
              :action="uploadUrl"
              :headers="headers"
              :limit="1"
              :file-list="model.picList"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :on-exceed="handleExceed">
              <i class="el-icon-plus"></i>
            </upload>
            <img v-else :src="model.cover" alt="" style="width:100px;height:100px">
          </FormItem>
          <FormItem label="适用对象:" prop="target">
            <Input v-model="model.target" style="width:500px" type="text" :maxlength="100" show-word-limit/>
          </FormItem>
          <FormItem label="驳回原因:" prop="reason" v-if="title == '详情' && model.auditStatus == 3">
            <Input v-model="model.reason" style="width:500px" type="textarea" :maxlength="1000" show-word-limit/>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import util from '@/libs/util.js';
import upload from '@/components/upload'
export default {
  name: 'editItem',
  components: {upload},
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      uploadUrl: util.baseUrl + "api/common/upload",
      //ID
      id: null,
      loading: true,
      showModel: false,
      //表单参数
      model: {
        id: null,
        bankId: null,
        productName: null,
        guaranteeWay: null,
        rate: null,
        timeLimit: null,
        amount: null,
        type: null,
        detail: null,
        target: null,
        picList: [],
        cover: '',
        reason: ''
      },
      rules: {
        productName: [{required: true, message: '贷款产品名称', trigger: 'blur'}],
        guaranteeWay: [{required: true, message: '担保方式', trigger: 'blur'}],
        rate: [{required: true, message: '利率范围', trigger: 'blur'}],
        timeLimit: [{required: true, message: '贷款期限', trigger: 'blur'}],
        amount: [{required: true, message: '贷款额度', trigger: 'blur'}],
        type: [{required: true, message: '产品类别', trigger: 'blur'}],
        detail: [{required: true, message: '项目详情', trigger: 'blur'},
          {max: 1000, message: '不能超过1000字', trigger: 'blur'}],
        cover: [{required: false, message: '产品封面', trigger: 'blur'}],
        target: [{required: true, message: '适用对象', trigger: 'blur'}],
      },
      disabled: false,
      headers: {
        Authorization: localStorage.token,
      },
    };
  },
  mounted() {
    console.log(this.disabled,'😃');
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.model.cover = response.result.realPath || ''
      }
    },
    handleRemove(file, fileList) {
      this.model.cover = ''
      this.model.picList = fileList
    },
    handleExceed(file, fileList) {
      this.$message.error('只能上传一张图片')
    },
    //验证是否为图片
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg'
      // const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 2MB!')
      // }
      return true
    },
    save() {
      console.log(this.model)
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          util.http.post("/api/bank/product/save", _this.model)
            .then(function (response) {
              if (response.data.code === 200) {
                _this.$Notice.success({
                  title: '保存成功!'
                });
                _this.$parent.handleOk()
                _this.closeModel()
              } else {
                _this.$Notice.success({
                  title: response.data.message
                });
                _this.loding = false;
                _this.$nextTick(() => {
                  _this.loading = true;
                });
              }
            })
        } else {
          _this.loading = false;
          _this.$nextTick(() => {
            _this.loading = true;
          });
        }
      })
    },
    openModel() {
      this.$refs.form.resetFields()
      this.showModel = true
    },
    closeModel() {
      this.$set(this, 'model', this.$options.data.call(this).model)
      this.$refs.form.resetFields()
      this.loading = true
      this.showModel = false
    },

  }
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}

.ivu-modal {
  width: 1000px;
}

</style>
